
type HttpMethods = "GET" | "POST" | "PUT" | "DELETE";

interface Request {
  headers?: string[][];
  method: HttpMethods;
  body?: string | FormData;
}

export function handleFetch<TResponseData>({
  url,
  method,
  body,
  cacheDuration = 0,
}: {
  url: string;
  method: HttpMethods;
  body?: unknown;
  cacheDuration?: number;
}) {
  const request: Request = {
    headers: [["content-type", "application/json"]],
    method,
  };

  if (cacheDuration === 0 && request.headers) {
    request.headers.push(["pragma", "no-cache"]);
    request.headers.push(["cache-control", "no-cache"]);
  }

  if (body) {
    if (body instanceof FormData) {
      request.body = body;
      request.headers = undefined;
    } else request.body = JSON.stringify(body);
  }

  return new Promise<TResponseData>(function (resolve, reject) {
    if (cacheDuration > 0) {
      const cache = localStorage.getItem(url);
      if (cache) {
        const o = JSON.parse(cache);
        if (Date.now() <= o.expires) return resolve(o.data);
      }
    }

    fetch(url, request as RequestInit)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.result === "failure") {
          reject(response.data);
        } else if (response.result === "success") {
          if (cacheDuration > 0) {
            localStorage.setItem(
              url,
              JSON.stringify({
                expires: Date.now() + cacheDuration,
                data: response.data,
              })
            );
          }

          resolve(response.data);
        } else throw "Unhandled API Result";
      })
      .catch(function (error) {
        console.error(error);
      });
  });
}
